import { TitleCasePipe } from "@angular/common";



const titleCasePipe = new TitleCasePipe();

export class TaskFilters {



  public staticFilters;
  public optionalFilters = [];

  public dropdowns = ['typecondition']

  constructor(private entities){

    this.staticFilters = [

      {
        entity: this.entities.task.entity,
        field: {
          name: 'typecondition_id',
          type: 'select',
          label: 'Estado',
          width: 1,
          dynamic: true,
          dropdown_data: {
            value: 'id',
            text: 'name',
            entity: 'typecondition'
          },
          options: [
            {
              value:  -1,
              text: 'Todos'
            },
          ]
        }
      },
      {
        entity: this.entities.claim.entity,
        field: {
          name: 'number',
          type: 'text',
          label: titleCasePipe.transform(this.entities.claim.labels.form),
          width: 2
        }
      },
      {
        entity: this.entities.task.entity,
        field: {
          name: 'created_at',
          type: 'date',
          label: 'Creada',
          width: 2,
          from: true
        }
      }

    ]

  }

}

